module.exports = __webpack_public_path__ + "img/P10241-enter-settings.168cf5de.svg";